window.log = () => {
  const event = new CustomEvent('log')
  window.dispatchEvent(event)
}
import('./bootstrap')
